import Resource from './Resource';

export default class CurrentSchedule extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !routeParams.settings ? 'current-schedule' : `current-schedule/${routeParams.settings}`;

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
